const QuestionType = {
  TEXT: 'text',
  NUMBER: 'number',
  OPTIONS: 'multi-select',
  EMAIL: 'email',
  PHONE: 'phone',
  NAME: 'name',
  LENGTH: 'length',
  WEIGHT: 'weight',
  DATE: 'date',
};

const LeadQuestionType = [
  QuestionType.TEXT,
  QuestionType.OPTIONS,
  QuestionType.EMAIL,
  QuestionType.PHONE,
  QuestionType.NAME,
];

const PostPaymentQuestionType = [
  QuestionType.TEXT,
  QuestionType.NUMBER,
  QuestionType.OPTIONS,
  QuestionType.LENGTH,
  QuestionType.WEIGHT,
  QuestionType.DATE,
];

const HiddenFieldType = {
  TEXT: 'hidden',
};

/**
 * System field IDs for the lead form.
 * These match the propertiesByCustomKey mapping in the server's leadsForm.js.
 */
const LeadFormSystemFieldId = {
  NAME: 'name',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  COACH: 'coach',
  PHONE_NUMBER: 'phoneNumber',
  GOAL: 'goal',
  AGE: 'age',
  GENDER: 'gender',
  OCCUPATION: 'occupation',
  INSPIRATION: 'inspiration',
  FINANCIAL_COMMITMENT: 'financialCommitment',
  INSTAGRAM_HANDLE: 'instagramHandle',
};

/**
 * System field IDs for the post-payment form.
 * These match the propertiesByCustomKey mapping in the server's postPaymentForm.js.
 */
const PostPaymentFormSystemFieldId = {
  EMAIL: 'email',
  COACH: 'coach',
  ACTIVITY_LEVEL: 'activityLevel',
  CURRENT_WORKOUT_DAYS: 'currentWorkoutDays',
  DAYS_AVAILABLE_TO_WORKOUT: 'daysAvailableToWorkout',
  WEIGHTS_EXPERIENCE: 'weightsExperience',
  BIRTHDATE: 'birthdate',
  BIOLOGICAL_SEX: 'biologicalSex',
  HEIGHT_FT: 'heightFt',
  HEIGHT_IN: 'heightIn',
  HEIGHT_CM: 'heightCm',
  CURRENT_WEIGHT_LBS: 'currentWeightLbs',
  CURRENT_WEIGHT_KGS: 'currentWeightKgs',
  WEEKLY_WEIGHT_GOAL_LBS: 'weeklyWeightGoalLbs',
  WEEKLY_WEIGHT_GOAL_KGS: 'weeklyWeightGoalKgs',
  LONG_TERM_WEIGHT_GOAL_LBS: 'longTermWeightGoalLbs',
  LONG_TERM_WEIGHT_GOAL_KGS: 'longTermWeightGoalKgs',
  WEEKLY_WEIGHT_GOAL: 'weeklyWeightGoal',
  DIET_RESTRICTIONS: 'dietRestrictions',
  PREFERRED_WORKOUT_DAYS: 'preferredWorkoutDays',
  WORKOUT_LOCATION: 'workoutLocation',
  EXCLUDED_INGREDIENTS: 'excludedIngredients',
};

/**
 * Combined set of all system-defined field IDs across all form types.
 * A question whose id matches one of these cannot be edited or deleted by coaches.
 */
const SYSTEM_FIELD_IDS = [
  ...new Set([
    ...Object.values(LeadFormSystemFieldId),
    ...Object.values(PostPaymentFormSystemFieldId),
  ]),
];

export default QuestionType;
export {
  HiddenFieldType,
  LeadQuestionType,
  PostPaymentQuestionType,
  LeadFormSystemFieldId,
  PostPaymentFormSystemFieldId,
  SYSTEM_FIELD_IDS,
};
